declare global {
  interface Window {
    __gxChatEntryInbox?: { drain: () => MessageEvent[] };
  }
}

export function takePendingChatEntryMessages(): MessageEvent[] {
  const inbox = window.__gxChatEntryInbox;
  delete window.__gxChatEntryInbox;
  return inbox?.drain() ?? [];
}
